import Marquee from "react-fast-marquee";

const HOME_BRANDS = [
  "TATA",
  "RADHA",
  "SHREE",
  "JAIRAJ",
  "SARWOTTAM",
  "RADHA RHINO 600+",
];

export const BrandsTicker = () => {
  return (
    <div
      data-testid="brands-ticker"
      className="relative border-y border-black/5 bg-white py-7"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-white to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-white to-transparent" />
      <Marquee speed={45} gradient={false} pauseOnHover>
        {HOME_BRANDS.concat(HOME_BRANDS).map((b, i) => (
          <div
            key={`${b}-${i}`}
            className="mx-8 flex items-center gap-6 md:mx-12"
          >
            <span className="font-display text-3xl uppercase tracking-tighter text-[#1c1c1e]/70 transition-colors hover:text-[#1c1c1e] md:text-5xl">
              {b}
            </span>
            <span
              aria-hidden
              className="inline-block h-2 w-2 rotate-45 bg-[#e85a1c]"
            />
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default BrandsTicker;
